import apiClient from '@u/apiClient.js'
import GetEnaosConfigByItemIdController from '@/wayfinder/actions/App/Http/Controllers/Item/GetEnaosConfigByItemIdController'
import GetEnaosOptionConfigByItemIdController from '@/wayfinder/actions/App/Http/Controllers/Item/GetEnaosOptionConfigByItemIdController'
import AddItemToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Item/AddItemToEnaosController'
import AddItemForSalesOptionToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Item/AddItemForSalesOptionToEnaosController'
import HideItemToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Item/HideItemToEnaosController'
import LinkItemOptionToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Item/LinkItemOptionToEnaosController'
import UnlinkItemOptionToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Item/UnlinkItemOptionToEnaosController'
import DeleteItemToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Item/DeleteItemToEnaosController'
import DeleteItemOptionToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Item/DeleteItemOptionToEnaosController'

export default {
  fetchEnaosItemsConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetEnaosConfigByItemIdController.get({ item: payload.item_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaosItemsOptionConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetEnaosOptionConfigByItemIdController.get({ item: payload.item_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createEnaosItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemToEnaosController.post({ item: payload.item_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createEnaosItemOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemForSalesOptionToEnaosController.post({
            item: payload.item_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteEnaosItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteItemToEnaosController.delete(
            { item: payload.item_id, enaos_item: payload.enaos_item_id },
            { query: { enaos_id: payload.data.enaos_id } }
          )
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteEnaosItemOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteItemOptionToEnaosController.delete(
            { item: payload.item_id, enaos_item: payload.enaos_item_id },
            { query: { enaos_id: payload.data.enaos_id } }
          )
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  hideEnaosItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          HideItemToEnaosController.post({
            item: payload.item_id,
            enaos_item: payload.enaos_item_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  linkEnaosItemAndOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          LinkItemOptionToEnaosController.post({
            item: payload.item_id,
            enaos_item: payload.enaos_item_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  unlinkEnaosItemAndOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UnlinkItemOptionToEnaosController.post({
            item: payload.item_id,
            enaos_item: payload.enaos_item_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
